import { createContext } from 'react';
import type { Dispatch } from 'react';
import { SyncStatus } from '@/enums/syncStatus';
import type { NotesAction, NotesState } from '@/types/note';
import { initialNotesState } from './notesReducer';

export interface NotesRuntime {
  readonly syncStatus: SyncStatus;
  readonly lastError: string | null;
}

/**
 * Split into two contexts so components that only need to dispatch never
 * re-render when notes state changes. Consumers should always use the hook
 * helpers in `useNotes` / `useNotesDispatch` rather than reading these directly.
 */
export const NotesStateContext = createContext<NotesState>(initialNotesState);
export const NotesRuntimeContext = createContext<NotesRuntime>({
  syncStatus: SyncStatus.Idle,
  lastError: null,
});
export const NotesDispatchContext = createContext<Dispatch<NotesAction>>(() => {
  throw new Error('NotesDispatchContext used outside NotesProvider');
});
